import React, { Component } from 'react';
import { Example, Properties, SourceCode } from 'examples';
import List from '../List/List';
import MoreFilters from '../MoreFilters/MoreFilters';
import Sidebar from '../Sidebar/Sidebar';
import SidebarTab from './SidebarTab';

const ITEMS = [
  {
    imageUrl: 'https://images.unsplash.com/photo-1485872304698-0537e003288d?dpr=1&auto=format&fit=crop&w=168&h=112&q=80&cs=tinysrgb&crop=',
    title: 'Short Title',
  }, {
    imageUrl: 'https://images.unsplash.com/photo-1485601284679-a2f86e6f7dea?dpr=1&auto=format&fit=crop&w=1500&h=1000&q=80&cs=tinysrgb&crop=',
    title: 'Statehood Movement Grows in Columbia - the follow up',
    description: 'VCC Team FTW',
  }, {
    imageUrl: 'https://images.unsplash.com/photo-1485809876425-9c96ea4132fe?dpr=1&auto=format&fit=crop&w=168&h=112&q=80&cs=tinysrgb&crop=',
    title: 'Bernie Sanders on Debbie Wasserman Schultz Resignation - she made the right decision for the future of the Democratic party',
    description: 'Vimond Media Solutions',
  }
];

export default class SidebarExample extends Component {

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  onChange = e => this.setState(e.target.value);

  render() {
    return (
      <Example {...this.props}>
        <Properties onChange={this.onChange} defaultProps={SidebarTab.defaultProps} propTypes={SidebarTab.propTypes} propValues={this.state}/>
        <Sidebar>
          <SidebarTab {...this.state}>
            <div className="filter-bar">
              <p>Custom filterbar is placed here</p>
              <MoreFilters>
                <p>Advanced filtering options can be displayed here</p>
              </MoreFilters>
            </div>
            <List items={ITEMS}/>
          </SidebarTab>
        </Sidebar>
        <SourceCode querySelector=".sidebar-tab-example .core-sidebar-content"/>
      </Example>
    );
  }

}
